export default function ElementDecorator({ children }) {
  return children;
}
